/* OBSIDIAN INDEX — theme.js  (vanilla, no dependencies) */
(function () {
  'use strict';

  var cfg = window.__theme || {};

  /* ---------- helpers ---------- */

  function money(cents) {
    try {
      return new Intl.NumberFormat(cfg.locale || 'de-DE', {
        style: 'currency',
        currency: cfg.currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function on(sel, evt, fn, root) {
    (root || document).querySelectorAll(sel).forEach(function (el) {
      el.addEventListener(evt, fn);
    });
  }

  /* ---------- drawers ---------- */

  var lastFocus = null;

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }

  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__veil')) {
      closeDrawers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------- cart ---------- */

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var body = document.querySelector('[data-cart-items]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="label dim">' + (cfg.strings.empty || 'Your bag is empty.') + '</p>';
    } else {
      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">'
          : '<span></span>';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="label dim">' + item.variant_title + '</div>' : '';
        return '<div class="cart-line">' + img +
          '<div><a class="label" href="' + item.url + '">' + item.product_title + '</a>' + variant +
          '<div class="qty" style="margin-top:.6rem;height:38px">' +
          '<button type="button" aria-label="-" data-line-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '">–</button>' +
          '<input type="text" value="' + item.quantity + '" readonly tabindex="-1">' +
          '<button type="button" aria-label="+" data-line-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div></div>' +
          '<div class="label">' + money(item.final_line_price) + '</div></div>';
      }).join('');
    }

    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = money(cart.total_price);
    });

    var bar = document.querySelector('[data-progress]');
    if (bar && cfg.freeShipping > 0) {
      var pct = Math.min(100, (cart.total_price / cfg.freeShipping) * 100);
      bar.querySelector('span').style.width = pct + '%';
      var msg = bar.parentNode.querySelector('[data-progress-text]');
      if (msg) {
        msg.textContent = pct >= 100
          ? (cfg.strings.shippingFree || 'Free shipping unlocked')
          : (cfg.strings.shippingLeft || 'Away from free shipping:') + ' ' + money(cfg.freeShipping - cart.total_price);
      }
    }
  }

  function fetchCart() {
    return fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    fetch(cfg.routes.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-line-change'), quantity: Number(btn.getAttribute('data-qty')) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  });

  on('[data-product-form]', 'submit', function (e) {
    e.preventDefault();
    var form = e.currentTarget;
    var btn = form.querySelector('[data-add]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(cfg.routes.add + '.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (res.status) {
          alert(res.description || res.message);
          return;
        }
        return fetchCart().then(function () { openDrawer('cart-drawer'); });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        form.submit();
      });
  });

  /* ---------- quantity stepper (product page) ---------- */

  on('[data-qty-step]', 'click', function (e) {
    var input = e.currentTarget.parentNode.querySelector('input');
    var next = Number(input.value) + Number(e.currentTarget.getAttribute('data-qty-step'));
    input.value = Math.max(1, next);
  });

  /* ---------- variant picking ---------- */

  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) { return; }

    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var addBtn = root.querySelector('[data-add]');

    function update() {
      var chosen = Array.prototype.map.call(root.querySelectorAll('.opt__row'), function (row) {
        var checked = row.querySelector('input:checked');
        return checked ? checked.value : null;
      });

      var match = data.filter(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = cfg.strings.unavailable || 'Unavailable'; }
        return;
      }

      idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        compareEl.textContent = match.compare_at_price > match.price ? money(match.compare_at_price) : '';
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (cfg.strings.add || 'Add to bag')
          : (cfg.strings.soldOut || 'Sold out');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', update);
    update();
  });

  /* ---------- collection sort ---------- */

  on('[data-sort]', 'change', function (e) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.currentTarget.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- reveal on scroll ---------- */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- initial cart paint ---------- */
  if (document.querySelector('[data-cart-items]')) fetchCart();
})();

/* ---------- product gallery: carousel on mobile ---------- */

(function () {
  function initGallery(root) {
    (root || document).querySelectorAll('.product__gallery').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('img');
      if (slides.length < 2) return;
      if (gallery.parentElement.classList.contains('product__gallery-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'product__gallery-wrap';
      gallery.parentElement.insertBefore(wrap, gallery);
      wrap.appendChild(gallery);

      var dots = document.createElement('div');
      dots.className = 'product__dots';
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Bild ' + (i + 1));
        b.addEventListener('click', function () {
          gallery.scrollTo({ left: gallery.clientWidth * i, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      wrap.appendChild(dots);

      var buttons = dots.querySelectorAll('button');
      var timer;
      function sync() {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        buttons.forEach(function (b, n) {
          b.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }

      gallery.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(sync, 60);
      }, { passive: true });

      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGallery(); });
  } else {
    initGallery();
  }

  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); });
})();
